import Link from "../../Link";

const Vue = () => {
    return (
        <div>
            <Link url="https://escuelavue.es/cursos/" title={"Escuela Vue"} />
            <Link url="https://www.youtube.com/playlist?list=PLPl81lqbj-4J-gfAERGDCdOQtVgRhSvIT" title={"Vue JS Desde 0 - Bluuweb"} />
        </div>
    );
}

export default Vue;